import { Fragment } from 'react';

import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

const entries = [
  { label: 'Version', value: process.env.NEXT_PUBLIC_VERSION },
  { label: 'Deployment ID', value: process.env.NEXT_PUBLIC_DEPLOYMENT_ID },
  { label: 'Hostname', value: typeof window !== 'undefined' ? window.location.host : undefined },
  { label: 'API Hostname', value: process.env.NEXT_PUBLIC_SERVER_URL },
];

export const BuildInfo = () => {
  return (
    <div className={stack({ gap: 8, p: 8 })}>
      <dl
        className={css({
          display: 'grid',
          gridTemplateColumns: 'max-content 1fr',
          gap: '4px 16px',
          textStyle: 'Text/L/Monospace/Regular',
        })}
      >
        {entries.map(({ label, value }) => (
          <Fragment key={label}>
            <dt className={css({ color: 'content.secondary' })}>{label}</dt>
            <dd>{value || '-'}</dd>
          </Fragment>
        ))}
      </dl>
    </div>
  );
};
